// Value of the transfer target for "no perimeter", as the api expects it in
// the usage query (the archive body sends null instead).
export const NO_PERIMETER_TARGET = "none";

// The usage decides which modal the archive button opens: a perimeter that
// never carried a mission is deleted, one with nothing left to move is simply
// archived, and one with active missions or members needs a destination.
export const getArchiveModalType = (usage) => {
    if (!usage.usedAt) return "perimeter_delete";
    if (!usage.activeMissions && !usage.members) return "perimeter_archive";
    return "perimeter_archive_transfer";
};
